<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->

<template>
    <div class="show-products-carousel-component ti-fs-regular">
        <h1 class="title mt-80 mb-35">{{ stepSelectionText }}</h1>
        <div v-if="productRecommendationsMessage"> {{ productRecommendationsMessage }}</div>
        <div class="row no-gutters ti-sliders ti-bg-color-white js-finder-products" data-swiper-carousels>
            <div class="pb-72 pb-md-100 col-12 ti-sliders-content">
                <div
                    ref="swiper"
                    :class="`col-12 swiper ti-swiper-container ti-swiper-container-pagination-bar pb-0 pb-md-24 ti-disable-swiper-imag es slider-product-watch-finder-results mt-32 mb-32`"
                    data-swiper-slider-init
                    data-swiper-pd-slider="watch-finder-results"
                    :style="carouselStyle"
                >
                    <div class="swiper-wrapper">
                        <div
                            v-for="(product, i) in products"
                            v-bind:key="'product-' + i"
                            class="swiper-slide"
                            :data-slider-position="i"
                        >
                            <div class="product-tile product ti-bg-color-gradient-gray-light" :data-pid="product.id">
                                <div class="ti-images-container" :data-swiper-slider="product.id">
                                    <a :href="product.custom.productLink" class="ti-images-link">
                                        <img
                                            ref="image"
                                            class="ti-picture-img w-100 lazyload lazyload img-fluid loaded"
                                            :alt="product.images.Shadow[0]['normal_square'].alt"
                                            loading="lazy"
                                            data-image-product
                                            :src="product.images.Shadow[0]['normal_square'].url"
                                            @load="setCarouselStyle"
                                        />
                                    </a>
                                    <button
                                        data-icon-linked-products-wishlist
                                        data-add-to-wishlist
                                        class="ti-btn-reset icon-heart-tile"
                                        v-bind:data-href="product.custom.wishlistUrl"
                                        :aria-label="heartBtnText"
                                        @click="addToWishlist()"
                                    >
                                        <span
                                            class="svg-wrapper svg-icon-heart-two"
                                            style="width: 24px"
                                            v-html="getIcon('icon-heart-two')"></span>
                                    </button>
                                </div>
                                <div class="ti-tile-body px-16" data-tile-body-bottom>
                                    <a class="ti-product-link d-flex ti-fs-12 ti-product-name mb-0 ti-font-weight-600" :href="product.custom.productLink">
                                        {{ product.productName }}
                                    </a>
                                    <div class="row no-gutters">
                                        <div class="col-12 ti-product-labels ti-fs-12 d-flex">
                                            {{ product.custom.movement }}
                                            {{ product.custom.productLinksMsg }}
                                        </div>
                                    </div>
                                    <div class="price ti-product-price ti-fs-12">
                                        <span class="ti-product-price-inner">
                                            <span class="ti-price-sales">
                                                {{ product.price.sales.formatted }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-none d-md-flex align-items-end justify-content-center position-absolute pd-pagination-wrapper">
                        <button class="ti-btn-reset swiper-button-prev position-static mr-15" :aria-label="prevBtnText"></button>
                        <div class="swiper-product-pagination-watch-finder-results  d-inline-flex w-auto"></div>
                        <button class="ti-btn-reset swiper-button-next position-static ml-15" :aria-label="nextBtnText"></button>
                    </div>
                </div>
            </div>
        </div>
        <div
            aria-live="polite"
            aria-atomic="true"
            class="ti-toast-section d-flex justify-content-center align-items-center position-fixed"
        >
            <div
                id="toast-wishlist-toast"
                class="toast ti-toast ti-bg-color-white hide"
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
            >
                <div class="toast-body font-weight-normal"></div>
            </div>
        </div>

        <StepsBarComponent :isResultsPage="true" />
        <NavButtonsComp :isResultsPage="true" />
    </div>
</template>

<script>
import StepsBarComponent from "./stepsBarComponent.vue";
import NavButtonsComp from "./navButtonsComponent.vue";
import svgIcon from "@cartridges/cartridges/app_tissot/cartridge/scripts/svgicons";
import wishlistHeart from "@cartridges/cartridges/app_tissot/cartridge/client/default/js/product/wishlistHeart";
import { productSlider } from "@cartridges/cartridges/app_tissot/cartridge/client/default/js/components/productSlider";
import "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default {
    components: { StepsBarComponent, NavButtonsComp },
    data() {
        return {
            products: this.$store.state.showproductscarousel,
            windowSize: 4,
            paginationFactor: 220,
            isMounted: false,
            carouselStyle: {},
        };
    },
    computed: {
        stepSelectionText: function () {
            return this.$store.state.quizData.translations.stepTitleSelection;
        },
        productRecommendationsMessage() {
            return this.$store.state.productRecommendationsMessage;
        },
        images: function () {
            return this.$store.state.quizData.images;
        },
        prevBtnText: function () {
            return this.$store.state.quizData.translations.prev;
        },
        nextBtnText: function () {
            return this.$store.state.quizData.translations.next;
        },
        heartBtnText: function () {
            return this.$store.state.quizData.translations.heartBtnText;
        }
    },
    mounted() {
        productSlider();
    },
    created() {
        window.addEventListener("resize", this.setCarouselStyle);
    },
    destroyed() {
        window.removeEventListener("resize", this.setCarouselStyle);
    },
    methods: {
        setCarouselStyle() {
            if (this.$refs.image && this.$refs.image.length > 0) {
                this.carouselStyle = { "--swiper-navigation-top-offset": this.$refs.image[0].offsetHeight / 2 + "px" };
            }
        },
        visitOnStore(url) {
            window.open(url, "_blank");
        },
        hasMoreThanOnePage() {
            return this.products.length > this.windowSize;
        },
        moveCarousel(direction) {
            if (this.hasMoreThanOnePage()) {
                if (direction === 1) {
                    this.$refs.carousel.appendChild(this.$refs.carousel.firstElementChild);
                } else if (direction === -1) {
                    this.$refs.carousel.prepend(this.$refs.carousel.lastElementChild);
                }
            }
        },
        getIcon(icon) {
            return svgIcon.getIcon(icon);
        },
        addToWishlist() {
            return wishlistHeart.addToWishlist();
        },
    },
};
</script>

<style lang="scss">
.show-products-carousel-component {
    text-align: center;
    --swiper-navigation-size: 53px;

    .title {
        font-weight: 400;
    }

    .ti-product-tile {
        .svg-wrapper svg {
            width: 1.375rem;
        }

        .icon-heart-tile {
            position: absolute;
            right: 16px;
            top: 16px;
            z-index: 1;
            cursor: pointer;
        }
    }
    .ti-swiper-container {
        overflow: hidden;
        padding-bottom: 2rem;
    }
    .product-tile:hover .ti-picture-img {
        transform: scale(1.03);
        transition: transform 0.2s ease-in;
    }
    .ti-picture-img {
        transform: scale(1);
        transition: transform 0.2s ease-in;
    }
    .swiper-button-prev,
    .swiper-button-next {
        border: 0;
        background-color: transparent;
    }
    .swiper-product-pagination {
        position: absolute;
        transition: opacity 0.3s;
        z-index: 10;
        margin: 0 auto;
        text-align: center;

        &.swiper-pagination-bullets {
            .swiper-pagination-bullet-active-next-next {
                margin-bottom: 1px;

                ~ .swiper-pagination-bullet {
                    margin-bottom: 1px;
                }
            }

            .swiper-pagination-bullet-active-prev-prev {
                margin-bottom: 1px;
            }
        }
        .swiper-pagination-bullet {
            width: 3px;
            height: 3px;
            transform: scale(1);
        }

        .swiper-pagination-bullet-active-prev,
        .swiper-pagination-bullet-active-next,
        .swiper-pagination-bullet-active-main {
            width: 6px;
            height: 6px;
            transform: scale(1);
        }

        .swiper-pagination-bullet-active-main {
            background-color: #000;
        }

        .swiper-pagination-bullets-dynamic {
            margin: 0 auto;
            text-align: center;
        }
    }
}
</style>
